import React, { useEffect, lazy } from 'react'
import { Outlet } from 'react-router-dom';
import { useSelector } from "react-redux";
const Footer = lazy(() => import('../../Footer/Footer'));
const MainTemplate = () => {

    const homePage = useSelector((state) => state.homePage);

    const updateMetaTags = (title, description, keywords) => {
        // Update title
        document.title = title || 'Default Title';

        // Update or create meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            document.head.appendChild(metaDescription);
        }
        metaDescription.content = description || 'Default description';

        // Update or create meta keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
            metaKeywords = document.createElement('meta');
            metaKeywords.name = 'keywords';
            document.head.appendChild(metaKeywords);
        }
        metaKeywords.content = keywords || 'default,keywords';

        // Update Open Graph tags (for social sharing)
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.content = title;

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription) ogDescription.content = description;
    };
    useEffect(() => {
        const post_meta = homePage?.post_meta;
        if (post_meta)
            updateMetaTags(post_meta.nfdc_meta_title, post_meta.nfdc_meta_description, post_meta.nfdc_meta_keywords);
    }, [homePage]);
    return (
        <>
            <div className='text-container'>
                <Outlet />
            </div>

            <Footer />
        </>
    )
}

export default MainTemplate